/**
 * Turns a stored chat image value into something an <img> can load.
 *
 * `chat_message_images.image` holds inline base64 today. With the backend's
 * RC_MEDIA_URL_FIELDS flag on it holds an https blob URL instead (the
 * environment containers allow public blob reads, so no SAS is needed), so the
 * chat has to accept both:
 *
 *   - `data:...` or `http(s)://...` → as it is
 *   - bare base64                   → wrapped in a data URL, mime sniffed from
 *                                     the first bytes, else PNG (what
 *                                     addBase64Prefix always used)
 *
 * Kept free of imports so it can be unit-tested with plain `node --test`.
 */
export function toImageSrc(value: unknown): string {
    if (typeof value !== "string") return "";
    const trimmed = value.trim();
    if (!trimmed) return "";
    if (trimmed.startsWith("data:") || /^https?:\/\//i.test(trimmed)) return trimmed;
    return `data:${sniffBase64Mime(trimmed) ?? "image/png"};base64,${trimmed}`;
}

/** Mime type from the base64 magic bytes, or null when it is not one we know. */
export function sniffBase64Mime(base64: string): string | null {
    if (base64.startsWith("/9j/")) return "image/jpeg";
    if (base64.startsWith("iVBOR")) return "image/png";
    return null;
}
